'use client';

import { use } from 'react';
import { useSelectionStore } from './private/use-selection-store';

/**
 * Returns the page's resolved search params as a plain object.
 *
 * Only for blocks that key off params which aren't product options, like
 * `?upgrade=`. For anything option-related use `useSelectedVariant`, which
 * validates values against the product's real options.
 *
 * Requires <Suspense>.
 */
export function useResolvedSearchParams() {
  const selectionStore = useSelectionStore();

  return use(selectionStore.searchParams);
}
